export default __webpack_public_path__ + "static/media/Engine.75f66ac3.svg";